import { FRONT_COLUMNS } from "@onesolution/constants";
import { MONDAY_SCHEMAS, type MONDAY_TYPES } from "@onesolution/monday";
import { gql } from "graphql-request";
import { requestAndFormat } from "../utils";

export const clientInfosQuery = (context: { boards: { front: string } }) =>
	requestAndFormat({
		defaultParams: {
			boardIds: [context.boards?.front],
			columnIds: [
				FRONT_COLUMNS.boxFolderId,
				FRONT_COLUMNS.boxUserGroupId,
				FRONT_COLUMNS.sso,
				FRONT_COLUMNS.featureFlag,
			],
		},
		gql: gql`
            query GetClientInfos(
                $boardIds: [ID!],
                $columnIds: [String!]!,
            ) {
                boards (ids:$boardIds) {
                    items_page {
                        items {
                            ${MONDAY_SCHEMAS.assets}
                        
                            column_values(ids: $columnIds) {
                                ${MONDAY_SCHEMAS.base}
                                ${MONDAY_SCHEMAS.dropdown}
                            } 
                        }
                    }
                }
           }`,
		resultKey: "boards[0].items_page.items",
		outType: {} as MONDAY_TYPES["base"] &
			MONDAY_TYPES["assets"] & {
				boxFolderId: MONDAY_TYPES["text"];
				boxUserGroupId: MONDAY_TYPES["text"];
				sso: MONDAY_TYPES["dropdown"];
				featureFlag: MONDAY_TYPES["dropdown"];
			},
	});
